var styles = {"box":"WalletForm_box_1qx6f_1","title":"WalletForm_title_1qx6f_66","body":"WalletForm_body_1qx6f_78","row":"WalletForm_row_1qx6f_131","bottom-group":"WalletForm_bottom-group_1qx6f_140","text":"WalletForm_text_1qx6f_154","text-center":"WalletForm_text-center_1qx6f_166","no-margin":"WalletForm_no-margin_1qx6f_170","icon":"WalletForm_icon_1qx6f_181","value":"WalletForm_value_1qx6f_185"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
